function getDomainParts(value) {
  if (value.includes('.')) {
    const [domain, ...tldParts] = value.split('.');

    return {
      domain,
      tldParts: tldParts.filter((val) => Boolean(val)),
    };
  }

  return {
    domain: value,
    tldParts: [],
  };
}

export default getDomainParts;
